module.exports = __webpack_public_path__ + "img/cart-buy-hen.5e4086c0.png";